import React from "react";
import { Modal, Button } from "react-bootstrap";
import "../../.csscode/Table.css";

const ReportChoiceModal = ({ show, onClose, onSelect }) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="md" // ✅ small width
      contentClassName="custom-modal-content" // ✅ custom style
    >
      <Modal.Header closeButton>
        <Modal.Title>Select Report Format</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <Button variant="primary" className="m-2" onClick={() => onSelect("pdf")}>
          PDF
        </Button>
        <Button variant="success" className="m-2" onClick={() => onSelect("word")}>
          Word
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default ReportChoiceModal;
